import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coc',
  templateUrl: './coc.component.html',
  styleUrls: ['./coc.component.sass']
})
export class COCComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
